<template>
    <div class="card-changing-btn" :class="selected" @click="setCard">
        <img
            v-if="cardId === 'pressure'"
            class="icon"
            :class="selected"
            src="@/assets/pressure.svg"
            alt="pressure"
        />
        <div v-else class="icon" :class="cardIcon"></div>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
    name: 'CardChangingButton',
    props: {
        cardId: {
            type: String,
            default: 'None',
        },
        cardIcon: {
            type: String,
            default: 'None',
        },
    },
    computed: {
        ...mapState(['mobileCardId']),
        selected() {
            return this.mobileCardId === this.cardId ? 'selected' : ''
        },
    },
    methods: {
        ...mapMutations(['setMobileCardId']),
        setCard() {
            this.setMobileCardId(this.cardId)
        },
    },
}
</script>

<style lang="scss" scoped>
.card-changing-btn {
    background-color: #ffffff;
    box-shadow: 5px 5px 5px 2px rgba(136, 136, 136, 0.2);
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    filter: opacity(0.5);

    &.selected {
        filter: opacity(1);
    }
    
    .icon {
        width: 60%;
        height: 60%;
    }
}
</style>
